import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { SocialLinks } from "@/components/social-links";
export function SiteFooter() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="max-w-sm"><div className="flex items-center gap-2"><img src="/Plample_logo.svg" alt="" width={24} height={24} className="size-6 object-contain" /><span className="text-sm font-semibold tracking-tight">Plample</span></div><p className="mt-4 text-sm leading-relaxed text-muted-foreground">The honest laptop guide for students. We gather reviews, specs and prices so you don't have to.</p><SocialLinks className="mt-5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 py-12 sm:flex-row sm:items-end sm:px-8">{t0}<div className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm text-muted-foreground"><Link className="hover:text-foreground" href="/laptops">All laptops</Link><Link className="hover:text-foreground" href="/contact">Contact</Link><Link className="hover:text-foreground" href="/extension">Amazon extension</Link><Link className="hover:text-foreground" href="/privacy/extension">Extension privacy</Link></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <footer className="mt-24 border-t border-border/60 bg-surface">{t1}<div className="border-t border-border/60 px-5 py-4 text-center text-[11px] text-muted-foreground sm:px-8">© {new Date().getFullYear()} Plample. Built for students, not for spec sheets.</div></footer>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}